module.exports = __webpack_public_path__ + "img/khqr.3f09b853.jpg";